const html = require('choo/html')

const Screen = require('./components/screen.js')
const ContextMenu = require('./components/contextmenu.js')
const ChipElement = require('./elements/chip.js')
const ButtonIcon = require('./elements/buttonicon.js')

function LoadingMessage (text) {
  return html`
  <div id="app">
    <div class="grid-12">
      <div class="column-12 huge-letters" style="text-align: center;">
        ${text}
      </div>
    </div>
  </div>`
}
module.exports = function FullscreenPlayerView (state, emit) {
  if (!state.glitchesLoaded) {
    emit('set-fullscreen-flags')
    emit('load-vm')
    emit('load-glitches')
    return LoadingMessage('Loading Glitches')
  }
  if (!state.partsLoaded) {
    emit('load-parts')
    return LoadingMessage('Loading Parts')
  }
  if (state.query.shareData && !state.sceneData) {
    emit('load-from-share-url', state.query.shareData)
    return LoadingMessage('Loading From URL Data')
  }
  if (!state.projectMetadata) {
    emit('fetch-project-metadata', state.params.project_id)
    return LoadingMessage('Fetching Project Metadata')
  }
  if (!state.sceneMetadata) {
    emit('fetch-scene-metadata', 'main')
    return LoadingMessage('Fetching Scene Metadata')
  }
  if (!state.sceneData) {
    emit('fetch-scene-sb3', 'main')
    return LoadingMessage('Fetching Project sb3')
  }

  if (!state.loadedVM) {
    emit('load-scene')
    return LoadingMessage('Loading Project into Scratch VM')
  }
  const logoUrl = `graphics/logos/${state.projectMetadata.id}.png`
  const logo = html`
    <div class ="logo">
          <a href="https://www.makeymakey.com" target="_blank">
           <img class = "logo-img" style="width:100%; 
           left:0;"  src = "${logoUrl}"
            alt = "Makey Makey Logo">
          </a>
      </div>
  `
  let questionURL = `https://www.makeymakey.com`
  if (state.projectMetadata.tutorialLink) {
    questionURL = state.projectMetadata.tutorialLink
  }

  // open tutorialUrl in a separate tab
  function questionClick () {
    window.open(questionURL, '_blank').focus()
  }

  const chipElement = ChipElement({

    children: [

      ButtonIcon({
        icon: state.masterVolume === 0 ? 'mute' : 'unmute',
        onClick: () => emit('toggle-mute')
      }),
      ButtonIcon({
        icon: state.isMenuOpen ? 'cross' : 'question',
        onClick: questionClick
      })
    ]
  })

  const chipWidth = 65
  const chipMargin = 35

  return html`
    <div id="app" style="width:187vh; max-height:100%;">
      <div class="grid-12" style="width:100%;">
        <div class="column-2" style="padding-top:4rem; width:10.5%; ">
          ${logo}
        </div>
        <div class="column-8 fullscreen" style="width:67%;">
          ${Screen(state, emit)}
        </div>
        <div class="column-2 fullscreen" style="width:22%">
          <div class="context-menu">
          ${ContextMenu(state, emit)}
            <div style="margin-top:142rem; 
              width:${chipWidth}%; 
              margin-left:${chipMargin}%"
            >
              ${chipElement}
            </div>
          </div>
        </div>
      </div>
    </div>
  `
}

